import React from 'react';
import { Dropdown } from 'react-bootstrap';
import uniqid from 'uniqid';
import { exportPDF } from '../../../../../../exports';
import { useDataGridStore } from '../../../_Store';
import styles from './pdfBtn.module.scss';
import { useI18N } from '../../../../../../hooks';

export default function PDFBtn() {
    const i18n = useI18N();
    const { localeKey } = i18n;
    const [{ tableData, queriedTableData, renderedTableData, exports, columnFields, activeGridPage, liveRender }] = useDataGridStore();

    return (
        <>
            {//PDF exports
                exports?.pdf && exports?.options ? (
                    <Dropdown className={`${styles.pdfDropdown} pr-0`}>
                        <Dropdown.Toggle variant="link" id={uniqid()} size="sm">
                            <i className="fas fa-file-pdf text-danger cursor"></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Header>Export to PDF</Dropdown.Header>
                            {
                                !liveRender ?
                                    <Dropdown.Item
                                        //href="#/"
                                        onClick={() => setTimeout(() => { exportPDF(tableData, columnFields) }, 0)}
                                    >
                                        ({tableData.length}) {i18n.translateThis('All', i18n.localize.all)}
                                </Dropdown.Item>
                                    : null
                            }

                            {
                                (typeof exports.customOptions !== 'boolean') ?
                                    <>
                                        {
                                            exports.customOptions?.map((option, index) => {
                                                return (
                                                    <React.Fragment key={index}>
                                                        {
                                                            (option.type === 'pdf') ?
                                                                <Dropdown.Item
                                                                    //href="#/"
                                                                    onClick={() => {
                                                                        setTimeout(() => {
                                                                            option.onClick();
                                                                        }, 0)
                                                                    }}
                                                                >
                                                                    {option.label}
                                                                </Dropdown.Item> : null
                                                        }
                                                    </React.Fragment>
                                                )

                                            })
                                        }
                                    </> : null
                            }

                            {!liveRender ? (
                                <Dropdown.Item
                                    href="#/"
                                    onClick={() =>
                                        setTimeout(() => {
                                            exportPDF(queriedTableData, columnFields);
                                        }, 0)
                                    }
                                >
                                    ({queriedTableData.length}) {i18n.translateThis('Filtered', i18n.localize.filtered)}
                                </Dropdown.Item>
                            ) : null}
                            {
                                (liveRender && !(exports.customOptions)) ?
                                    <Dropdown.Item
                                        href="#/"
                                        onClick={() =>
                                            exportPDF(
                                                renderedTableData[activeGridPage],
                                                columnFields
                                            )
                                        }
                                    >
                                        ({queriedTableData.length}) Current
                                </Dropdown.Item>
                                    : null
                            }


                        </Dropdown.Menu>
                    </Dropdown>
                ) : exports?.excel ? (
                    <i
                        className="fas fa-file-pdf text-danger mr-3 cursor"
                        onClick={() => exportPDF(tableData, columnFields)}
                    ></i>
                ) : null
            }
        </>
    )
}